export default __webpack_public_path__ + "static/background-lines-d1947e016cf93577b7f4d77f37f678d6.png";